import { webTopicSubUnsub } from "../../apis";
import { createUserPreference, getFcmUserTopicDetails, updateUserPrefernce } from "../../apis/nontransactional";
import { getApiExchangeNameFromMktSegId, getDecryptLocalStorage, getMktSegIdFromApiExchangeName } from "../../utils/global_functions";
import { BUSINESS_LAYER_RESPONSE, EXCHANGE_NAME_NOTIFICATION, ORDER_PRODUCT_TYPES } from "../../utils/global_variables";

const _regExpAlphabet = new RegExp("^(?=.*[a-z])(?=.*[A-Z]).*$");
const _regExpNumber = new RegExp("^(?=.*\\d).*$");
const _regExpSpecialCharacter = new RegExp("^(?=.*[-+_!@#$%^&*., ?]).*$");

async function _getPushNotificationTopics() {
    try {
        const objResp = await getFcmUserTopicDetails();

        const topicDetails = objResp?.data?.result.map((item) => {
            return {
                TopicNo: item?.nTopicNo,
                TopicName: item?.sTopicName,
                TopicDisplayName: item?.sTopicDisplayName,
                bIsCompulsory: parseInt(item?.bIsCompalsory) > 0 ? true : false,
                bIsDisplay: parseInt(item?.bIsDisplay) > 0 ? true : false,
                //if topic is compalsory we will set selected by default
                Selected: parseInt(item?.bIsCompalsory) > 0 ? true : false
            };
        });

        return { status: true, message: null, data: topicDetails }

    } catch (error) {

        console.log("error", error)

        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data }

        } else {
            return { status: false, message: null, data: {} }

        }
    }
};

function _getDynamicProductType(product, exchange, productTypes) {
    let objProductType = {}

    if (exchange.includes('EQ') && (product === ORDER_PRODUCT_TYPES.INTRADAY)) {
        objProductType = productTypes?.find(productType => productType?.sDefaultProductType === ORDER_PRODUCT_TYPES.MARGIN)
    }
    else if (!exchange.includes('EQ') && product === ORDER_PRODUCT_TYPES.DELIVERY) {
        objProductType = productTypes?.find(productType => productType?.sDefaultProductType === ORDER_PRODUCT_TYPES.CARRYFORWARD)
    }
    else if (product === ORDER_PRODUCT_TYPES.BTST) {
        objProductType = productTypes?.find(productType => productType?.sDefaultProductType === ORDER_PRODUCT_TYPES.PTST)
    }
    else {
        objProductType = productTypes?.find(productType => productType?.sDefaultProductType === product)
    }
    return objProductType;
}


function _loadProductTypeAsPerExchange(nMarketSegId, objLoginSession, productTypes) {
    const tempProductTypeArray = []
    const exchange = getApiExchangeNameFromMktSegId(nMarketSegId)
    const arrProductTypes = objLoginSession?.data?.product_types
    arrProductTypes?.forEach((product) => {
        if (product !== ORDER_PRODUCT_TYPES.COVER && product !== ORDER_PRODUCT_TYPES.BRACKET) {
            if (product === ORDER_PRODUCT_TYPES.MTF || product === ORDER_PRODUCT_TYPES.BTST) {
                if (nMarketSegId === 1 || nMarketSegId === 3 || nMarketSegId === 15) {
                    const dynamicProductType = _getDynamicProductType(product, exchange, productTypes)
                    tempProductTypeArray.push({
                        name: dynamicProductType?.sDescription, value: dynamicProductType?.sDefaultProductType
                    });
                }
            }
            else {
                const dynamicProductType = _getDynamicProductType(product, exchange, productTypes)
                tempProductTypeArray.push({
                    name: dynamicProductType?.sDescription, value: dynamicProductType?.sDefaultProductType
                });
            }
        }
    })
    return tempProductTypeArray;
}

// Deepti B. persisting selected product type and protection in local storage 
function _getExchangeTypes(exchanges, currentPreference, userId) {
    if (exchanges?.length) {
        const userPreferenceExchanges = currentPreference?.sExchange ? JSON.parse(currentPreference?.sExchange) : []
        const arrExchangeTypes = exchanges?.map(exchange => {
            const preferenceExchange = userPreferenceExchanges?.find(exchangeType => exchangeType?.exchange === EXCHANGE_NAME_NOTIFICATION[exchange])

            if (preferenceExchange) {
                return preferenceExchange;
            } else {
                const selectedProduct = getDecryptLocalStorage(`PRODUCT_TYPE_${userId}_${getMktSegIdFromApiExchangeName(exchange)}` )
                const selectedInput = getDecryptLocalStorage(`SETTING_INPUT_${userId}_${getMktSegIdFromApiExchangeName(exchange)}` )
                return {
                    "exchange": EXCHANGE_NAME_NOTIFICATION[exchange],
                    "productType": selectedProduct,
                    "marketSegmentId": getMktSegIdFromApiExchangeName(exchange),
                    "selected": false,
                    "protection": selectedInput
                }
            }
        })

        return arrExchangeTypes;
    }
    else {
        return []
    }
}

//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
async function _updateUserPreference(currentPreference, keysToUpdate) {
    try {
        if (Object.keys(currentPreference)?.length) {
            const { _lastChangedAt, ...preference } = currentPreference
            const preferencePayload = {
                ...preference, ...keysToUpdate
            }
            const objResp = await updateUserPrefernce(preferencePayload);
                return { status: true, message: null, data: objResp?.data?.data }
            
        } else {
            const objUserPreferenceResp = await createUserPreference({
                "sProfilePicPath": "",
                "sOrder": null,
                "sNotification": "",
                "sInAppNotification": null,
                "sTheme": "light",
                "sExchange": null,
                ...keysToUpdate //Prachi T - 07-12-2023 - BT-109052 - Breeze- Font and Colour Settings
            });
            if (objUserPreferenceResp?.data?.data) {
                return { status: true, message: null, data: objUserPreferenceResp?.data?.data }
            }
            else {
                return { status: true, message: null, data: null }
            }
        }


    } catch (error) {
        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data }

        } else {
            return { status: false, message: null, data: null }

        }
    }
}

async function _pushNotificationTopicSubUnsub(notificationPayload, userId) {
    try {
        if (userId && notificationPayload?.length) {
            const fcmToken = getDecryptLocalStorage(`FCM_TOKEN_${userId}`);
            const updatedPayload = {
                "token": fcmToken,
                "subList": notificationPayload?.filter(notification => notification?.Selected === true)?.map(notification => notification?.TopicName) || [],
                "unSublist": notificationPayload?.filter(notification => notification?.Selected === false)?.map(notification => notification?.TopicName) || []
            }
            const objResp = await webTopicSubUnsub(updatedPayload);

            return { status: true, message: null, data: objResp?.data }
        }
        else {
            return { status: false, message: null, data: null }
        }
    } catch (error) {
        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data }

        } else {
            return { status: false, message: null, data: null }

        }
    }
}
//Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End



//Shuaib P - 22-11-2023-BT-109047_Breeze-User Profile --Start

function _getUserInitials(strUserName) {
    try {
        const arrName = strUserName?.split(' ');
        let strInitials = '';
        arrName?.forEach(val => {
            strInitials = strInitials + val.slice(0, 1);
        });
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: strInitials };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}




function _getInitialsFromUserName(strUserName) {
    try {
        const words = strUserName.split(/\s+/);
        const firstLetter = words[0].slice(0, 1);
        const secondLetter = words.length > 1 ? words[1].slice(0, 1) : '';
        const result = `${firstLetter}${secondLetter}`;
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: result.toUpperCase() };
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.FAILURE, error };
    }
}

//Shuaib P - 22-11-2023-BT-109047_Breeze-User Profile --End

//Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - Start
async function _reSubUnSubPushNotificationTopic(payload) {
    try {
        const objResp = await webTopicSubUnsub(payload);
        return { status: true, message: null, data: objResp?.data }
    } catch (error) {
        if (error?.response?.data) {
            return { status: false, message: null, data: error?.response?.data }

        } else {
            return { status: false, message: null, data: null }

        }
    }
}
//Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings - End


export { _getInitialsFromUserName, _getUserInitials, _getPushNotificationTopics, _loadProductTypeAsPerExchange, _getDynamicProductType, _getExchangeTypes, _updateUserPreference, _pushNotificationTopicSubUnsub, _reSubUnSubPushNotificationTopic, _regExpSpecialCharacter, _regExpNumber, _regExpAlphabet }